export const RESOLVE_MODULE_EXTENSIONS = ['.js', '.jsx', '.ts', '.tsx', '.mjs', '.mts', '.cjs', '.cts', '.vue'];

export const UTOOLS_BUILD_MODE = 'utools-build-mode';

export const FILE_NAME = 'preload.js'
export const SSR_MODE = 'SSR bundle'
